<section class="confirm-dialog">
  <div class="confirm-dialog__header" [ngClass]="{ '!mb-0': description }">
    <!-- icon -->
    <i class="iconsax confirm-dialog__icon" icon-name="info-circle"></i>
    <!-- title -->
    <h4 class="confirm-dialog__title">{{ title | translate }}</h4>
  </div>
  <div class="confirm-dialog__body">
    @if (description) {
      <p class="confirm-dialog__description">{{ description | translate }}</p>
    }
  </div>

  <div class="confirm-dialog__buttons">
    <!-- ignore button -->
    <pwj-button
      icon="chevron-right"
      [rotateIconInRtl]="true"
      [iconReversePosition]="true"
      variant="normal"
      color="danger"
      (click)="close()"
      >{{ 'global.no' | translate }}</pwj-button
    >
    <!-- accept button -->
    <pwj-button
      icon="chevron-right"
      [rotateIconInRtl]="true"
      [iconReversePosition]="true"
      variant="normal"
      color="success"
      (click)="confirm()"
      >{{ 'global.yes' | translate }}</pwj-button
    >
  </div>
</section>
